import HightlightChars from "./HightlightChars";

export default HightlightChars;
